import { render, staticRenderFns } from "./ModificaSegnalazione.vue?vue&type=template&id=5e3e08a2"
import script from "./ModificaSegnalazione.vue?vue&type=script&lang=js"
export * from "./ModificaSegnalazione.vue?vue&type=script&lang=js"
import style0 from "./ModificaSegnalazione.vue?vue&type=style&index=0&id=5e3e08a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports